import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import Course from "../../models/course.model";

import { CourseSpecParams, PaginationCourse } from "../../models/pagination";
import { CourseService } from "../../services/course.service";

@Component({
  selector: "ngx-view-courses",
  styleUrls: ["./view-courses.component.scss"],
  templateUrl: "./view-courses.component.html",
})
export class ViewCoursesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "home"; //home / tutor / detail

  pagination = new PaginationCourse();
  specParams = new CourseSpecParams();
  cursor: any;

  courses?: Course[] = [];
  displayCourses?: Course[] = [];

  cloud = true;
  loading = false;
  loadingStudent = false;
  done = false;

  userLogin: User;
  strSearch = "";

  constructor(
    public userService: UserService,
    private courseService: CourseService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        this.userLogin = user;
        if (user && user.uid != this.specParams.uid) {
          this.specParams.uid = user.uid;
        } else {
          this.specParams.uid = "anonymous";
        }
        this.specParams.pageNumber = 1;
        this.specParams.pageSize = 12;
        //this.retrieveCourses();
        this.getCourses();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  retrieveCourses(): void {
    this.loading = true;

    this.courseService.getPublishedCourses(this.specParams).subscribe(
      (response) => {
        this.loading = false;
        this.pagination = response;
        this.courses = [...this.courses, ...response.data];

        this.displayCourses = [...this.courses];
        this.cloud = false;
      },
      (error) => {
        this.cloud = true;
        this.getCourses();
      }
    );
  }

  loadMore() {
    this.specParams.pageSize = 12;

    if (this.cloud) {
      this.getCourses();
    } else {
      this.specParams.pageNumber++;
      this.retrieveCourses();
    }
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  newCourse(): void {
    this.router.navigateByUrl(`/tutor/new-course`);
  }

  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.displayCourses = this.courses.filter(
      function (item) {
        let tags = item.tags ? item.tags.toString().toLowerCase() : "";
        return (
          item.title.toLowerCase().includes(this.strSearch) ||
          item.description.toLowerCase().includes(this.strSearch) ||
          tags.includes(this.strSearch)
        );
      },
      { strSearch: this.strSearch }
    );
  }

  private getCourses(): void {
    this.loading = true;

    this.courseService
      .getFsPublishedCourses("", this.specParams.pageSize, this.cursor)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          const uid = this.specParams.uid;
          let i = 0;
          querySnapshot.forEach((doc) => {
            let data = new Course();
            data = doc.data();
            data.id = doc.id;
            if (data.createdBy != uid) {
              this.courses.push(data);
              i++;
            }
          });

          if (i == 0) {
            this.loadMore();
          } else {
            this.displayCourses = [...this.courses];
          }
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {});
  }
}
